/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { getCaptureDesign } from "api/services/product.api";

const CaptureDesign = () => {
  const [searchParams] = useSearchParams();

  const getDesign = async () => {
    try {
      const guid: any = searchParams.get("guid");
      if (guid) {
        const isGuid = await getCaptureDesign(guid);
        if (isGuid && isGuid?.status === 200 && isGuid?.data) {
          console.log("isGuid : ", JSON.parse(isGuid?.data?.JsonData));
        }
      }
    } catch (error: any) {
      throw new Error(error?.message);
    }
  };

  useEffect(() => {
    getDesign();
  }, []);

  return (
    <>
      <h1> design</h1>
    </>
  );
};

export default CaptureDesign;
